var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"imgan",staticClass:"item-imgan",style:(_vm.styles)},[(_vm.detail.imageType === 'diy')?_c('DecorationModuleCode',{attrs:{"content":_vm.detail.config}}):_c('img',{style:({ width: _vm.styles.width, height: _vm.styles.height }),attrs:{"src":_vm.detail.bI,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }